import $ from 'jquery';
import _ from 'lodash';
import Highcharts from 'highcharts';

function buildChart($csv_chart_area, csv_download_url, papa_data) {
  // ヘッダーを削除
  papa_data.data.shift();
  console.log(papa_data.data);
  let chart_labels = [];
  // 問題集種別のリストを作成
  chart_labels = _.map(papa_data.data, (o) => {
    return o[2];
  });
  chart_labels = _.uniq(chart_labels);
  const chart_data = [];

  _.each(chart_labels, (label) => {
    chart_data.push({
      name: label,
      y: _.reduce(papa_data.data, (sum, n) => {
        let rep_sum = sum;
        if (n[2] === label) {
          rep_sum += 1;
        }
        return rep_sum;
      }, 0),
    });
  });

  console.log(chart_data);

  $csv_chart_area.highcharts({
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
    },
    title: {
      text: '問題集の種類の割合',
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %',
          style: {
            color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black',
          },
        },
      },
    },
    series: [{
      name: 'Brands',
      colorByPoint: true,
      data: chart_data,
    }],
  });
}

export default buildChart;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/charts/selectedtraining/sttest_set_list.js